import { Bar } from '@frontend/shared/lib/vue-chartjs/BaseChart.js';
import { mixins } from 'vue-chartjs';
const { reactiveProp } = mixins;

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: ['data', 'options'],
  options: {
    legend: {
      display: false,
    },
  },
  mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options);
  },
};
